export const CATALOGS = {
    "en": {
        "name": "English",
        "numberLocale": "en",
        "texts": {},
        "help": [
            "For more information access these resources:",
            "",
            " game documentation          directory 'doc'",
            " Outgun website              http://outgun.mbnet.fi/",
            " Brazilian Outgun website    http://outgun.sf.net/",
            " ",
            "Controls",
            " ",
            " Move               Arrow keys or keypad",
            " Shoot              Control",
            " Run                Shift",
            " Strafe             Alt or Alt Gr",
            " ",
            "Other keys",
            " ",
            " Talk               Just type your message and hit Enter",
            " Team talk          Begin your message with a dot ('.')",
            " Change team        Control + End",
            " Suicide            Delete",
            " Drop flag          Page Down",
            " Map list           F2",
            " Team stats         F3",
            " Player stats       F4",
            " Server info        F5",
            " Vote map change    F8",
            " Screenshot         F11",
            " Show more messages Insert",
            " ",
            "Game concept",
            " ",
            " You are a member of a team, either red or blue, assigned to you at random when you connect. Your goal is to help your team to win, by capturing the enemy flag. To capture the flag, a member of your team must steal the enemy flag and bring it to your team's flag, provided your flag has not been stolen already.",
            " ",
            "Health and energy",
            " ",
            " If your health drops to zero, you die. Energy is used for running, shooting and health protection when you have the shield powerup. Health and energy regenerate to 200 with time.",
            " ",
            "Minimap",
            " ",
            " On the upper-right corner of the screen is the minimap. It shows your teammates and the opponents seen by them. If you have the shadow powerup, it shows all the opponents who don't have the shadow themselves.",
            " ",
            "Powerups",
            " ",
            " If you see an item lying on the ground, grab it. It's a special powerup item.",
            " ",
            " Weapon upgrade  An additional rocket and more energy",
            " Turbo           More speed",
            " Shadow          Invisibility, see opponents on the minimap",
            " Weapon power    Your shots make more damage",
            " Megahealth      More health and energy",
            " Shield          Your health is protected while the shield lasts",
            " Deathbringer    Damage players on the same room when you die"
        ],
        "splash": [
            "Outgun 1.0.3 r617M, copyright © 2002-2010 multiple authors.",
            " ",
            "Outgun is free software under the GNU GPL, and you are welcome to redistribute it under certain conditions. Outgun comes with ABSOLUTELY NO WARRANTY. For details, see the accompanying file COPYING.",
            " ",
            "To help us remove any remaining bugs, you can let Outgun automatically send us a notification when an unexpected failure occurs. You can choose between no reporting, minimal information, and a complete report. The minimal information includes no more than the file name and line number of the failing assertion, and the version of Outgun. The complete report also includes a copy of Outgun's stack. This information is only used to find the cause of the failure. We can't contact you for more information, so it is recommended to also send an e-mail with more details.",
            " ",
            "Choose the preferred mode below with left and right arrow keys, and close the menu with Enter or Esc. After the first time of starting Outgun, you can find this screen in the Options menu."
        ]
    },
    "pt-BR": {
        "name": "Português (Brasil)",
        "numberLocale": "pt_BR",
        "texts": {
            "English": "Português (Brasil)",
            "Outgun client": "Outgun - Cliente",
            "Connected to $1 ($2)": "Connectado à $1 ($2)",
            "Replay on $1": "Replay em $1",
            "Spectating on $1": "Espectador em $1",
            "ERRORS:$1": "ERROS:$1",
            "$1/$2p $3k/s v$4 port:$5": "$1/$2j $3k/s v$4 porta:$5",
            "Esc:quit": "Esc:Sair",
            "second": "segundo",
            "seconds": "segundos",
            "minute": "minuto",
            "minutes": "minutos",
            "hour": "hora",
            "hours": "horas",
            "day": "dia",
            "days": "dias",
            "week": "semana",
            "weeks": "semanas",
            "year": "ano",
            "years": "anos",
            "$1 s": "$1 s",
            "$1 min": "$1 min",
            "$1%": "$1%",
            "OK": "OK",
            "Cancel": "Cancelar",
            "unknown": "desconhecido",
            "private": "privado",
            "invalid": "inválido",
            "default": "padrão",
            "none": "nenhum",
            "on": "ligado",
            "off": "desligado",
            "special": "especial",
            "disabled": "desabilitado",
            "minimal": "mínimo",
            "complete": "completo",
            "never": "nunca",
            "always": "sempre",
            "in same room": "na mesma sala",
            "single-roomed": "uma sala",
            "multi-roomed": "várias salas",
            "New version: $1": "Nova versão: $1",
            "Server list": "Lista de servidores",
            "Disconnect": "Desconectar",
            "Options": "Opções",
            "Help": "Ajuda",
            "Exit Outgun": "Sair do Outgun",
            "Update server list": "Atualizar lista de servidores",
            "Refresh servers": "Atualizar servidores",
            "Refresh status": "Atualizar status",
            "Show favorite servers": "Mostrar servidores favoritos",
            "Manually enter IP": "Inserir IP manualmente",
            "IP address": "Endereço IP",
            "Add to favorite list": "Adicionar à lista de favoritos",
            "Add server": "Adicionar servidor",
            "Insert = add to favorites    Delete = remove server": "Insert = adicionar aos favoritos    Delete = remover servidor",
            "IP address            Ping D Players Vers. Host name": "Endereço IP           Ping D Jogad Versão  Nome do host",
            "Player options": "Opções de jogador",
            "Name": "Nome",
            "Get random name": "Obter nome aleatório",
            "Favorite colors": "Cores favoritas",
            "Ranking password": "Senha do ranking",
            "Registration status": "Status do registo",
            "Take part in the ranking": "Participar do ranking",
            "Remove server-specific player passwords": "Remover senhas específicas de servidores",
            "Game options": "Opções de jogo",
            "Lag prediction": "Previsão de atraso ('lag')",
            "Lag prediction amount": "Quantidade de previsão de atraso ('lag')",
            "Bandwidth for out-of-room players (cps)": "Largura de banda para jogadores fora da sala ('cps')",
            "Save game messages": "Salvar as mensagens do chat",
            "Show flag messages": "Mostrar mensagens sobre bandeiras",
            "Show killing messages": "Mostrar mensagens sobre mortes",
            "Save game statistics": "Salvar estatísticas do jogo",
            "Save replay statistics": "Salvar estatísticas do replay",
            "Show stats after the round": "Mostrar estatísticas após a partida",
            "Show server info when connected": "Mostrar informações do servidor quando conectado",
            "Stay dead when in a menu at round start": "Permanecer morto quando em um menu no início da partida",
            "Underline master-authenticated players": "Sublinhar jogadores autenticados pelo servidor mestre",
            "Underline server-authenticated players": "Sublinhar jogadores autenticados pelo servidor",
            "Get server list at startup": "Obter lista de servidores na inicialização",
            "Controls": "Controles",
            "Keyboard layout": "Leiaute do teclado",
            "Use keypad for moving": "Usar teclado numérico para movimento",
            "Arrow keys in statistics": "Teclas de seta nas estatísticas",
            "Use arrow keys to edit message input": "Usar setas para editar a entrada da mensagem",
            "Preferrably aim with": "Mirar preferencialmente com",
            "With mouse aim move relative to": "Com a mira pelo mouse, mover em relação a",
            "Keyboard turning speed": "Velocidade de giro pelo teclado",
            "Enable joystick control": "Habilitar controle por joystick",
            "Moving stick": "Haste de movimento",
            "Joystick buttons (0 = disabled)": "Botões do joystick (0 = desabilitado)",
            "Shoot ": "Atirar",
            "Run   ": "Correr",
            "Strafe": "Esquivar",
            "Mouse control (buttons: 0 = disabled)": "Controle pelo mouse (botões: 0 = desabilitado)",
            "Sensitivity": "Sensibilidade",
            "Active controls": "Controles ativos",
            "Active joystick buttons": "Botões do joystick ativos",
            "Active mouse buttons": "Botões do mouse ativos",
            "Screen mode": "Modo de tela",
            "Color depth": "Profundidade de cor",
            " desktop": "desktop",
            "$1-bit": "$1-bit",
            "Screen size": "Tamanho da tela",
            "Windowed mode": "Modo janela",
            "Use page flipping": "Usar 'page flipping'",
            "Alternative page flipping method": "Método alternativo de 'page flipping'",
            "Current refresh rate": "Taxa de atualização atual",
            "$1 Hz": "$1 Hz",
            "Apply changes": "Aplicar alterações",
            "Theme and font": "Tema e fonte",
            "Theme": "Tema",
            "Background theme": "Tema de fundo",
            "Prefer main theme background": "Preferir fundo do tema principal",
            "Colour theme": "Cor do tema",
            "Prefer main theme colours": "Preferir cores do tema principal",
            "Font": "Fonte",
            "Graphic options": "Opções gráficas",
            "Show player names": "Mostrar nomes dos jogadores",
            "Rooms on screen in each direction in game": "Salas na tela em cada direção no jogo",
            "Rooms on screen in each direction in replay": "Salas na tela em cada direção no replay",
            "Scrolling": "Rolagem",
            "Antialiasing": "Antiserrilhamento ('antialiasing')",
            "Less transparency effects": "Menos efeitos de transparência",
            "Continuous textures between rooms": "Texturas contínuas entre salas",
            "Disappeared players on minimap": "Jogadores desaparecidos no minimapa",
            "Highlight returned and dropped flags": "Destacar bandeiras retornadas e soltas",
            "Make flags extra-visible": "Fazer as banderas mais visíveis",
            "Show flag disappearance positions": "Mostrar posições de desaparecimento das bandeiras",
            "Highlight self after spawn": "Destacar-se ao nascer",
            "Markers for nearby players and flags in game": "Marcadores para jogadores e bandeiras próximas no jogo",
            "Markers for nearby players and flags in replay": "Marcadores para jogadores e bandeiras próximas no replay",
            "Box visible area on map in game": "Delimitar área visível no mapa no jogo",
            "Let view follow over map border": "Deixar a visão seguir a borda do mapa",
            "Allow parts of map to repeat on screen": "Permitir que partes do mapa se repitam na tela",
            "Stats screen alpha": "Opacidade das telas de estatísticas",
            "FPS limit": "Limite de FPS",
            "Map info mode": "Modo de informação do mapa",
            "Sound options": "Opções sonoras",
            "Sounds enabled": "Sons habilitados",
            "Volume": "Volume",
            "Choose language": "Escolher idioma",
            "Bug report policy": "Política de relatório de bugs",
            "Automatic bug reporting": "Relatório automático de bugs",
            "Local server (running)": "Servidor local (em execução)",
            "Local server": "Servidor local",
            "Add to public serverlist": "Adicionar à lista pública de servidores",
            "Server port": "Porta do servidor",
            "Autodetect IP": "Autodetectar IP",
            "Start server": "Iniciar servidor",
            "Play on the server": "Jogar no servidor",
            "Stop server": "Parar servidor",
            "Replays": "Replays",
            "Date - Server - Map": "Data - Servidor - Mapa",
            "Spectate": "Espectador",
            "Relay host": "Host de retransmissão",
            "No password set": "Nenhuma senha definida",
            "Initializing...": "Inicializando...",
            "Socket error": "Erro de soquete",
            "Sending login...": "Enviando login...",
            "Error sending": "Erro ao enviar",
            "Waiting for response...": "Aguardando resposta...",
            "No response": "Sem resposta",
            "Invalid response received": "Resposta inválida recebida",
            "Master server unavailable": "Servidor mestre indisponível",
            "Logged in": "Logado",
            "Login failed: check password": "Falha no login: verifique a senha",
            "Logged in; sent to server": "Logado; enviado ao servidor",
            "Logged in; server accepted": "Logado; aceito pelo servidor",
            "Error: server rejected": "Erro: rejeitado pelo servidor",
            "Capture limit": "Limite de capturas",
            "Time limit": "Limite de tempo",
            "Extra-time": "Tempo extra",
            "Flag return delay": "Atraso de retorno das bandeiras",
            "Player collisions": "Colisão entre jogadores",
            "Friendly fire": "Fogo amigo",
            "Balance teams": "Equilibrar times",
            "Drop power-ups": "Derrubar poderes",
            "Invisible shadow": "'Shadow' invisível",
            "Shadowed see each other": "Invisíveis vêem-se",
            "Switch deathbringer": "'Deathbringer' anulável",
            "One hit shield": "'Shield' de um acerto",
            "Maximum weapon level": "'Weapon' máximo",
            "Powerups": "Poderes",
            "Minimum powerups": "Mínimo de poderes",
            "Maximum powerups": "Máximo de poderes",
            "Powerup time": "Tempo dos poderes",
            "Powerup add time": "Tempo adicional dos poderes",
            "Powerup max time": "Tempo máximo dos poderes",
            "$1% of rooms": "$1% das salas",
            "$1×$2 min": "$1×$2 min",
            "Trying to connect...": "Tentando conectar...",
            "Waiting for the game to start.": "Aguardando o início da partida.",
            "No response from server.": "Nenhuma resposta do servidor.",
            "Connection refused.": "Conexão recusada.",
            "No reason given.": "Nenhuma razão dada.",
            "Unknown reason code ($1).": "Código de razão desconhecido ($1).",
            "The server is full.": "O servidor está cheio.",
            "Protocol mismatch. Server: $1, client: $2.": "Incompatibilidade de protocolo. Servidor: $1, cliente: $2.",
            "Wrong player password.": "Senha de jogador incorreta.",
            "Wrong server password.": "Senha de servidor incorreta.",
            "You are banned from this server.": "Você está banido deste servidor.",
            "You have been disconnected.": "Você foi desconectado.",
            "Server was shut down.": "Servidor foi encerrado",
            "Connection timed out.": "Conexão expirou.",
            "You were kicked.": "Você foi chutado.",
            "You were kicked for being idle.": "Você foi chutado por estar ocioso.",
            "Internal error (client misbehaved).": "Erro interno (cliente se portou mal).",
            "Inactive": "Inativo",
            "Running": "Em execução",
            "Failed": "Falhou",
            "Contacting the servers...": "Contatando os servidores...",
            "Getting server list: connecting...": "Obtendo lista de servidores: conectando...",
            "Getting server list: receiving...": "Obtendo lista de servidores: recebendo...",
            "no response": "nenhuma resposta",
            "Belgium": "Bélgica",
            "Brazil": "Brasil",
            "Canada (French)": "Canadá (Francês)",
            "Czech Republic": "República Checa",
            "Denmark": "Dinamarca",
            "Dvorak": "Dvorak",
            "Finland": "Finlândia",
            "France": "França",
            "Germany": "Alemanha",
            "Italy": "Itália",
            "Norway": "Noruega",
            "Poland": "Polônia",
            "Portugal": "Portugal",
            "Russia": "Russia",
            "Slovakia": "Eslováquia",
            "Spain": "Espanha",
            "Sweden": "Suécia",
            "Switzerland": "Suiça",
            "United Kingdom": "Reino Unido",
            "United States": "Estados Unidos",
            "unknown ($1)": "desconhecido ($1)",
            "all messages": "todas as mensagens",
            "chat only": "apenas conversas",
            "players": "jogadores",
            "teams": "times",
            "change stats view": "visualização das estatísticas",
            "move player": "mover jogador",
            "keyboard (8-directional)": "teclado (8 direções)",
            "keyboard (smooth turning)": "teclado (giro suave)",
            "mouse (turning)": "mouse (girando)",
            "mouse (targeting)": "mouse (alvejando)",
            "room (up = up)": "sala (cima = cima)",
            "aim (up = forward)": "mira (cima = frente)",
            "up": "cima",
            "down": "baixo",
            "left": "esquerda",
            "right": "direita",
            "shoot": "atirar",
            "run": "correr",
            "strafe": "esquivar",
            "fade out": "desaparecer gradualmente",
            "hide early": "esconder imediatamente",
            "hide late": "esconder com atraso",
            "when all rooms aren't shown": "quando todas as salas não são mostradas",
            "if the border has doorways": "se a borda tiver portas",
            "Errors": "Erros",
            "(server)": "(servidor)",
            "+ $1 more": "+ $1 mais",
            "See the 'log' directory for more information.": "Consulte o diretório 'log' para obter mais informações.",
            "Internal error": "Erro interno",
            "This results from a bug in Outgun. To help us fix it, please send assert.log and stackdump.bin from the log directory and describe what you were doing to outgun@mbnet.fi": "Isso resulta de um bug no Outgun. Para nos ajudar a corrigi-lo, envie assert.log e stackdump.bin do diretório de log e descreva o que você estava fazendo para outgun@mbnet.fi",
            "Critical error": "Erro crítico",
            "1 password removed.": "1 senha removida.",
            "$1 passwords removed.": "$1 senhas removidas.",
            "No passwords found.": "Nenhuma senha foi encontrada.",
            "Please close and restart Outgun to complete the change of language.": "Por favor, reinicie o Outgun para completar a mudança de idioma.",
            "Invalid IP address.": "Indereço IP inválido.",
            "No help found. It should be in $1": "Nenhuma ajuda encontrada. Deve estar em $1",
            "Password": "Senha",
            "Save password": "Salvar senha",
            "Player password for $1": "Senha de jogador para $1",
            "Server password": "Senha de servidor",
            "<no theme>": "<sem tema>",
            "<no themes found>": "<nenhum tema encontrado>",
            "<no background>": "<sem fundo>",
            "(unnamed theme)": "(tema sem nome)",
            "$1 CAPTURED THE RED FLAG!": "$1 CAPTUROU A BANDEIRA VERMELHA!",
            "$1 CAPTURED THE BLUE FLAG!": "$1 CAPTUROU A BANDEIRA AZUL!",
            "$1 CAPTURED THE WILD FLAG!": "$1 CAPTUROU A BANDEIRA SELVAGEM!",
            "$1 LOST THE RED FLAG!": "$1 PERDEU A BANDEIRA VERMELHA!",
            "$1 LOST THE BLUE FLAG!": "$1 PERDEU A BANDEIRA AZUL!",
            "$1 LOST THE WILD FLAG!": "$1 PERDEU A BANDEIRA SELVAGEM!",
            "$1 GOT THE RED FLAG!": "$1 PEGOU A BANDEIRA VERMELHA!",
            "$1 GOT THE BLUE FLAG!": "$1 PEGOU A BANDEIRA AZUL!",
            "$1 GOT THE WILD FLAG!": "$1 PEGOU A BANDEIRA SELVAGEM!",
            "$1 RETURNED THE RED FLAG!": "$1 RETORNOU A BANDEIRA VERMELHA!",
            "$1 RETURNED THE BLUE FLAG!": "$1 RETORNOU A BANDEIRA AZUL!",
            "$1 DROPPED THE RED FLAG!": "$1 SOLTOU A BANDEIRA VERMELHA!",
            "$1 DROPPED THE BLUE FLAG!": "$1 SOLTOU A BANDEIRA AZUL!",
            "$1 DROPPED THE WILD FLAG!": "$1 SOLTOU A BANDEIRA SELVAGEM!",
            "$1 was nailed.": "$1 foi acertado em cheio.",
            "$1 was nailed by teammate $2.": "$1 foi acertado em cheio pelo companheiro de time $2.",
            "$1 was nailed by $2.": "$1 foi acertado em cheio por $2.",
            "$1 was choked.": "$1 foi sufocado.",
            "$1 was choked by teammate $2.": "$1 foi sufocado pelo companheiro de time $2.",
            "$1 was choked by $2.": "$1 foi sufocado por $2.",
            "$1 received a mortal blow.": "$1 recebeu um golpe mortal.",
            "$1 received a mortal blow from teammate $2.": "$1 recebeu um golpe mortal do companheiro de time $2.",
            "$1 received a mortal blow from $2.": "$1 recebeu um golpe mortal de $2.",
            "$1 defends the red carrier.": "$1 defendeu o carregador vermelho.",
            "$1 defends the blue carrier.": "$1 defendeu o carregador azul.",
            "$1 defends the red flag.": "$1 defendeu a bandeira vermelha.",
            "$1 defends the blue flag.": "$1 defendeu a bandeira azul.",
            "$1 is on a killing spree!": "$1 está em uma matança!",
            "$1's killing spree was ended by $2.": "A matança de $1 foi interrompida por $2.",
            "$1's killing spree was ended.": "A matança de $1 foi interrompida.",
            "$1 entered the game.": "$1 entrou no jogo.",
            "$1 left the game with $2 frags.": "$1 deixou o jogo com $2 pontos.",
            "$1 moved to blue team.": "$1 foi para o time azul.",
            "$1 moved to red team.": "$1 foi para o time vermelho.",
            "$1 and $2 swapped teams.": "$1 e $2 trocaram de time.",
            "$1 changed name to $2.": "$1 mudou seu nome para $2.",
            "*** Five minutes remaining": "*** Cinco minutos restantes",
            "*** One minute remaining": "*** Um minuto restante",
            "*** 30 seconds remaining": "*** 30 segundos restantes",
            "*** Time out - CTF game over": "*** Tempo esgotado - Fim de jogo",
            "*** Extra-time out - CTF game over": "*** Tempo extra esgotado - Fim de jogo",
            "*** Normal time out - extra-time started": "*** Termo normal esgotado - Tempo extra iniciado",
            "(sudden death)": "(morte súbita)",
            "*** Idle kick: move or be kicked in $1 seconds.": "*** Chute por inatividade: mova-se ou será chutado em $1 segundos.",
            "*** $1/$2 votes for mapchange.": "*** $1/$2 votos para mudança de mapa.",
            "Your vote has no effect until you vote for a specific map.": "Seu voto não tem efeito até que você vote em um mapa específico.",
            "(All players needed for $1 more seconds.)": "(Todos os jogadores necessários por mais $1 segundos.)",
            "This map is $1 ($2 of $3).": "Este é o mapa $1 ($2 de $3).",
            "This map is $1.": "Este é o mapa $1.",
            "CTF GAME OVER - FINAL SCORE: RED $1 - BLUE $2": "FIM DE JOGO - PLACAR FINAL: VERMELHO $1 - AZUL $2",
            "CAPTURE $1 FLAGS TO WIN THE GAME.": "CAPTURE $1 BANDEIRAS PARA VENCER O JOGO.",
            "TIME LIMIT IS $1 MINUTES.": "O TEMPO LIMITE É DE $1 MINUTOS.",
            "You are muted. You can't send messages.": "Você está mudo. Você não pode enviar mensagens.",
            "You have been unmuted (you can send messages again).": "Você não está mais mudo (você pode enviar mensagens novamente).",
            "You have been muted by $1 (you can't send messages).": "Você foi silenciado por $1 (você não pode enviar mensagens).",
            "$1 has unmuted $2.": "$1 cancelou o silêncio de $2.",
            "$1 has muted $2.": "$1 silenciou $2.",
            "You are being kicked from this server by $1!": "Você está sendo chutado deste servidor por $1!",
            "$1 has BANNED you from this server for $2!": "$1 BANIU você deste servidor por $2!",
            "$1 has kicked $2 (disconnect in 10 seconds).": "$1 chutou $2 (desconectando em 10 segundos).",
            "$1 has banned $2 (disconnect in 10 seconds).": "$1 baniu $2 (desconectando em 10 segundos).",
            "$1 decided it's time for a map change.": "$1 decidiu que é hora de uma mudança de mapa.",
            "$1 decided it's time for a restart.": "$1 decidiu que é hora de reiniciar.",
            "The admin": "O administrador",
            "Too much talk. Chill...": "Muita conversa. Relaxe...",
            "Disconnecting in $1...": "Desconectando em $1...",
            "This map is broken. There is an instantly capturable flag. Avoid it.": "Este mapa está quebrado. Há uma bandeira instantaneamente capturável. Evite isso.",
            "Updating your ranking score failed!": "Falha ao atualizar sua pontuação do ranking!",
            "Warning: This server has extensions enabled that give an advantage over you to players with a supporting Outgun client.": "Aviso: Este servidor possui extensões habilitadas que oferecem uma vantagem sobre você aos jogadores com um cliente de Outgun compatível.",
            "Saved screenshot to $1.": "Captura de tela salva para $1.",
            "Could not save screenshot to $1.": "Não foi possível salvar a captura de tela para $1.",
            "Downloading map \"$1\"...": "Copiando o mapa \"$1\" (CRC $2)...",
            "Status": "Status",
            "master authorized": "autorizado pelo servidor mestre",
            "recording": "gravando",
            "not recording": "não está gravando",
            "master auth pending": "autenticação pendente",
            "will record": "irá gravar",
            "will not record": "não irá gravar",
            "no ranking login": "sem login de ranking",
            "locally authorized": "autorizado localmente",
            "administrator": "administrador",
            "Say": "Dizer",
            "Say team": "Dizer ao time",
            "Command": "Comando",
            "RED TEAM WINS": "TIME VERMELHO VENCEU",
            "BLUE TEAM WINS": "TIME AZUL VENCEU",
            "GAME TIED": "JOGO EMPATADO",
            "SCORE $1 - $2": "PLACAR $1 - $2",
            "Waiting game start - next map is": "Aguardando o início do jogo - Próximo mapa:",
            "Loading map: $1 bytes": "Carregando mapa: $1 bytes",
            "VIROU": "VIROU",
            "SORVETE!": "SORVETE!",
            "Health": "Vida",
            "Energy": "Energia",
            "Power": "Power",
            "Turbo": "Turbo",
            "Shadow": "Shadow",
            "Weapon $1": "Weapon $1",
            "ET": "TE",
            "FPS:$1": "FPS:$1",
            "CHANGE": "MUDAR",
            "TEAMS": "TIMES",
            "EXIT": "SAIR",
            "MAP": "MAPA",
            "Server not responding": "Servidor não respondendo",
            "May be heavy packet loss,": "Possível perda pesada de pacotes,",
            "or the server disconnected.": "ou o servidor foi desconectado.",
            "Red Team": "Time Vermelho",
            "Blue Team": "Time Azul    ",
            "pings": "pings",
            "$1 capt": "$1 cap",
            "Team stats": "Estatísticas dos times",
            "Captures": "Capturas",
            "Kills": "Mortes (+)",
            "Deaths": "Mortes (-)",
            "Suicides": "Suicídios",
            "Flags taken": "Bandeiras pegas",
            "Flags dropped": "Bandeiras soltas",
            "Flags returned": "Bandeiras retornadas",
            "Shots": "Tiros",
            "Hit accuracy": "Precisão",
            "Shots taken": "Tiros tomados",
            "Movement": "Movimento",
            "Team power": "Força do time",
            "     Frags    total/in-row/most": "    Capturas -----total/atual/máx",
            "Ping     Capt Kills      Deaths Suicides": "Ping  Pts  |   Mortes+    Mortes- Suic",
            "         Flags          Carriers  Carry": " Band   Band    Band Carregad     Tempo",
            "taken dropped returned   killed    time": "pegas soltas retorna   mortos  carregad",
            "   Accuracy": "Tiros    Tiros-",
            "Shots   |  Taken  Movement     Speed": "  Precisão    | Movimento Velocidade",
            "          Average         Ranking": "    Tempo    Vida    -----------Ranking",
            "Playtime lifetime    rank  power  score": "  de jogo   média    Rank  Força Pontos",
            "Server map list": "Lista de mapas do servidor",
            " Nr Vote Title                Size  Author": " Nº Voto Nome                 Salas Autor",
            "<Random>": "<Aleatório>",
            "Sort order (space to cycle): $1": "Ordem de exibição ('espaço' para alternar): $1",
            "Map number": "Número do mapa",
            "Votes": "Votos",
            "Title": "Nome",
            "Size": "Salas",
            "Author": "Autor",
            "Favorites": "Favoritos",
            "Vote map number": "Votar número do mapa",
            "$1 players in the ranking.": "$1 jogadores no ranking.",
            "Joystick axes": "Eixos do joystick",
            "Joystick buttons": "Botões do joystick",
            "Traffic: $1 B/s": "Tráfego: $1 B/s",
            "in $1 B/s, out $2 B/s": "entrada $1 B/s, saída $2 B/s",
            "Information": "Informação",
            "Version $1": "Versão $1",
            "Possible thread priorities (-prio <val>):": "Prioridades possíveis de thread (-prio <val>):",
            "* Minimum: $1": "* Mínima: $1",
            "* Maximum: $1": "* Máxima: $1",
            "* System default (use -defaultprio): $1": "* Padrão do sistema (use -defaultprio): $1",
            "* Outgun default: $1": "* Padrão do Outgun: $1",
            "IP addresses:": "Endereço IP:",
            "Outgun - Saving map pictures": "Outgun - Salvando fotos dos mapas",
            "Map pictures saved to the directory '$1'.": "Fotos dos mapas salvas no diretório 'mappic'.",
            "Default colours generated to $1.": "Cores padrões geradas para $1.",
            "$1 can't be combined with other command line options.": "$1 não pode ser combinado com outras opções de linha de comando.",
            "$1 can only be followed by the source and target directory.": "$1 só pode ser seguido pelo diretório de origem e destino.",
            "-cport must be followed by a space and either a port number or minport:maxport.": "-cport deve ser seguido por um espaço e um número de porta ou minport:maxport.",
            "-cport X or -cport X:Y: X and Y must be in the range of 1 to 65535.": "-cport X ou -cport X:Y: X e Y devem estar no intervalo de 1 a 65535.",
            "-cport X:Y: Y must be greater than X.": "-cport X:Y: Y deve ser maior que X.",
            "-debug must be followed by a space and a number.": "-debug deve ser seguido por um espaço e um número.",
            "-debug X: X must be in the range of 0 to 2.": "-debug X: X deve estar no intervalo de 0 a 2.",
            "-fps must be followed by a space and a number.": "-fps deve ser seguido por um espaço e um número.",
            "-fps X: X must be in the range of 1 to 1000.": "-fps X: X deve estar no intervalo de 1 a 1000.",
            "-ip must be followed by a space and an IP address.": "-ip deve ser seguido por um espaço e um endereço IP.",
            "-ip X: X must be a valid IP address without :port.": "-ip X: X deve ser um endereço IP válido sem :port.",
            "-maxp must be followed by a space and a player count.": "-maxp deve ser seguido por um espaço e uma contagem de jogadores.",
            "-maxp X: X must be an even number in the range of 2 to $1.": "-maxp X: X deve ser um número par no intervalo de 2 a $1.",
            "-play must be followed by a hostname and optionally port.": "-play deve ser seguido por um nome de host e opcionalmente uma porta.",
            "-port must be followed by a space and a port number.": "-port deve ser seguido por um espaço e um número de porta.",
            "-port X: X must be in the range of 1 to 65535.": "-port X: X deve estar no intervalo de 1 a 65535.",
            "-replay must be followed by a filename.": "-replay deve ser seguido por um nome de arquivo",
            "-spectate must be followed by a hostname and port.": "-spectate deve ser seguido por um nome de host e uma porta.",
            "-sport must be followed by a space and minport:maxport.": "-sport deve ser seguido por um espaço e minport:maxport.",
            "-sport X:Y: X and Y must be in the range of 1 to 65535.": "-sport X:Y: X e Y devem estar no intervalo de 1 a 65535.",
            "-sport X:Y: Y must be greater than X.": "-sport X:Y: Y deve ser maior que X.",
            "The given priority $1 isn't within system limits. Run with -info for more information.": "A prioridade dada $1 não está dentro dos limites do sistema. Execute com -info para mais informações.",
            "Unknown command-line argument '$1'.": "Argumento '$1' de linha de comando desconhecido.",
            "Can't add '$1' to map rotation.": "Não é possível adicionar '$1' ao rodízio de mapas.",
            "Can't load: error in map '$1'.": "Não é possível carregar: erro no mapa '$1'.",
            "Can't start listen server.": "Não é possível iniciar o servidor local.",
            "Can't start the client.": "Não é possível iniciar o cliente.",
            "Can't start the server.": "Não é possível iniciar o servidor.",
            "Could not save map pictures to the directory '$1'.": "Não foi possível salvar as fotos dos mapas no diretório '$1'.",
            "Could not start spectating.": "Não foi possível iniciar o modo espectador.",
            "Couldn't initialize resolution $1×$2×$3 in any mode.": "Não foi possível inicializar a resolução $1×$2×$3 em nenhum modo.",
            "Couldn't initialize resolution $1×$2×$3 in $4 mode; reverted to $5.": "Não foi possível inicializar a resolução $1×$2×$3 no modo $4; revertido para $5.",
            "backbuffered fullscreen": "tela cheia backbuffered",
            "flipped fullscreen": "tela cheia flipped",
            "windowed": "janela",
            "Can't open game mod file '$1'.": "Não é possível abrir o arquivo de modificação do jogo '$1'.",
            "Can't read '$1'.": "Não é possível ler '$1'.",
            "Could not open replay file $1.": "Não foi possível abrir o arquivo de replay $1.",
            "Unrecognized gamemod setting: '$1'.": "Configuração de modificação do jogo não reconhecida: '$1'.",
            "Can't set $1 to '$2' - expecting $3.": "Não é possível alterar $1 para '$2' - esperando $3.",
            "0 or 1": "0 ou 1",
            "$1 or $2": "$1 ou $2",
            "one of no, balance, and shuffle": "no, balance, ou shuffle",
            "one of no, normal, and special": "no, normal ou special",
            "an even integer between 2 and $1": "um número inteiro par entre 2 e $1",
            "an integer": "um número inteiro",
            "an integer, at least $1": "um número inteiro, no mínimo $1",
            "an integer, at most $1": "um número inteiro, no máximo $1",
            "an integer between 0 and $1, or 'n %' with n 0 or greater": "um número inteiro entre 0 e $1, ou 'n %' com n 0 ou maior",
            "an integer, between $1 and $2, inclusive": "um número inteiro, entre $1 e $2, inclusive",
            "a real number": "um número real",
            "a real number, at least $1": "um número real, no mínimo $1",
            "a real number, at most $1": "um número real, no máximo $1",
            "a real number, between $1 and $2, inclusive": "um número real, entre $1 e $2, inclusive",
            "a real number or 'x %' with x 0 or greater": "um número real ou 'x %' com x 0 ou maior",
            "IP address without :port": "Endereço IP sem :port",
            "non-empty string": "linha não vazia",
            "two positive integers and optionally a real number between 0 and 1, separated by spaces": "dois números inteiros positivos e, opcionalmente, um número real entre 0 e 1, separados por espaços",
            ", or 0": ", ou 0",
            "Invalid map line: $1": "Linha inválida: $1",
            "Label '$1' not found: $2": "Etiqueta '$1' não encontrada: $2",
            "Label line not allowed in label block: $1": "Etiqueta não permitida no bloco de etiquetas: $1",
            "Map is missing a width, height or title.": "Faltando largura, altura ou título do mapa.",
            "Redefined map author.": "Autor do mapa redefinido.",
            "Redefined map height.": "Altura do mapa redefinida.",
            "Redefined map title.": "Nome do mapa redefinido.",
            "Redefined map width.": "Largura do mapa redefinida.",
            "Room line not allowed in label block: $1": "Linha de sala não permitida no bloco de etiquetas: $1",
            "Team $1, flag $2 on the wall.": "Time $1, bandeira $2 na parede.",
            "Team $1, spawn point $2 on the wall.": "Time $1, ponto de nascimento $2 na parede.",
            "Team $1, respawn area $2 does not have enough free space.": "Time $1, área de renascimento $2 não tem espaço livre suficiente.",
            "Two identical label names not allowed: $1": "Duas etiquetas idênticas não permitidas: $1",
            "Unrecognized map line: $1": "Linha não reconhecida: $1",
            "$1 is not an Outgun replay.": "$1 não é um replay de Outgun.",
            "'$1', given in master.txt is not a valid IP address.": "'$1', dado em master.txt, não é um endereço IP válido.",
            "Admin shell: unprintable characters, message ignored.": "Admin shell: caracteres não imprimiveis, mensagem ignorada.",
            "Alpha bitmaps must be 8-bit grayscale images; $1 is $2-bit.": "Os bitmaps alfa devem ser imagens de 8-bit em escala de cinza; $1 é de $2-bit.",
            "Class command without class name in auth.txt.": "Comando de classe sem nome de classe em auth.txt",
            "File '$1' contains invalid name for bot: $2": "Arquivo '$1' contém nome inválido para o bot: $2",
            "File '$1' contains no bot names.": "Arquivo '$1' não contém nomes de bot.",
            "Format error in replay file.": "Erro de formato no arquivo de replay.",
            "Invalid authorization class entry in auth.txt: \"$1\"": "Classe de autorização inválida em auth.txt: \"$1\"",
            "Invalid ban command (IP address) in auth.txt: \"$1\"": "Comando de banimento inválido (endereço IP) em auth.txt: \"$1\"",
            "Invalid line (no name) in auth.txt: \"$1\"": "Linha inválida (sem nome) em auth.txt: \"$1\"",
            "Invalid syntax in client.cfg (\"$1\").": "Sintaxe inválida em client.cfg (\"$1\").",
            "Invalid user command (no password) in auth.txt: \"$1\"": "Comando de usuário inválido (sem senha) em auth.txt: \"$1\"",
            "Map picture saver: Map '$1' is not a valid map file.": "Salvamento de fotos dos mapas: Mapa '$1' não é um arquivo de mapa válido.",
            "Replay $1 is a newer version ($2).": "Replay $1 é uma versão mais recente ($2).",
            "Syntax error in $1, line '$2'.": "Erro de sintaxe em $1, linha '$2'.",
            "This is a newer replay version ($1).": "Esta é uma versão de replay mais recente ($1).",
            "This is not an Outgun replay.": "Isto não é um replay de Outgun.",
            "Translation $1 can't be read.": "Tradução $1 não pode ser lida.",
            "Unknown data in client.cfg (\"$1\").": "Dados desconhecidos em client.cfg (\"$1\").",
            "Unrecognized command \"$1\" in auth.txt": "Comando não reconhecido \"$1\" em auth.txt",
            "Unusable mode in gfxmodes.txt: $1×$2×$3 (should be at least 320×200 with bits 16, 24 or 32).": "Modo inutilizável em gfxmodes.txt: $1×$2×$3 (necessário pelo menos 320×200 com 16, 24 or 32 bits).",
            "Width and height of textures must be powers of 2; floor texture $1 is $2×$3.": "Largura e altura de texturas devem ser potências de 2; textura de chão $1 é $2×$3.",
            "Width and height of textures must be powers of 2; wall texture $1 is $2×$3.": "Largura e altura de texturas devem ser potências de 2; textura de parede $1 é $2×$3.",
            "\"$1\" is not a valid IP address.": "\"$1\" não é um endereço IP válido.",
            "Port is missing from $1.": "Porta faltando de $1.",
            "Can't change max_players while players are connected.": "Não é possível alterar max_players enquanto os jogadores estão conectados.",
            "Can't create new thread. Insufficient system resources.": "Não é possível criar nova thread. Recursos do sistema insuficientes.",
            "Can't set server to run in the background.": "Não é possível definir o servidor para funcionar em segundo plano.",
            "No maps for rotation.": "Sem mapas para rodízio.",
            "Out of memory.": "Sem memória disponível.",
            "Ranking server rejected the server id/password. No more ranking transactions will be attempted until ranking_password is set again.": "Servidor do ranking rejeitou id/senha do servidor. Não serão tentadas mais transações de ranking até que ranking_password seja configurado novamente.",
            "Admin shell: $1": "Shell de admin.: $1",
            "Admin shell connection: $1": "Conexão com o shell de admin.: $1",
            "Admin shell connection: Not all written.": "Conexão com o shell de admin.: Nem tudo foi escrito.",
            "Connecting to relay: $1": "Conexão ao relay: $1",
            "Getting server list: $1": "Pegando a lista do servidor: $1",
            "Master talker: $1": "Comunicador mestre: $1",
            "Master talker: You have a deprecated Outgun version. The server is not accepted on the master list. Please update.": "Comunicador mestre:Você possuí uma versão inválida do Outgun. O servidor não o aceitará na lista mestre. Por-favor, atualize.",
            "Master talker: (Quit) $1": "Comunicador mestre: (Sair) $1",
            "Network error: $1": "Erro de rede: $1",
            "Website thread: $1": "Thread do website: $1",
            "Website thread: (Quit) $1": "Thread do website: (Sair) $1",
            "Can't open socket.": "Não é possível abrir soquete.",
            "Can't open socket for refreshing servers. $1": "Não é possível abrir soquete para atualizar servidores. $1",
            "Can't start network server on port $1.": "Não é possível iniciar servidor de rede na porta $1.",
            "Connection to the server closed.": "Conexão ao servidor fechada.",
            "Connection to the server closed: $1": "Conexão ao servidor fechada: $1",
            "Error connecting to \"$1\": $2": "Erro ao conectar-se a \"$1\": $2",
            "Error initializing network subsystem: $1": "Erro ao inicializar o subsistema de rede: $1",
            "Error opening a broadcast socket on any UDP port: $1": "Erro ao abrir um soquete de transmissão em qualquer porta UDP: $1",
            "Error opening a broadcast socket on UDP port $1: $2": "Erro ao abrir um soquete de transmissão na porta UDP $1: $2",
            "Error opening a socket on any TCP port: $1": "Erro ao abrir um soquete em qualquer porta TCP: $1",
            "Error opening a socket on any UDP port: $1": "Erro ao abrir um soquete em qualquer porta UDP: $1",
            "Error opening a socket on TCP port $1: $2": "Erro ao abrir um soquete na porta TCP $1: $2",
            "Error opening a socket on UDP port $1: $2": "Erro ao abrir um soquete na porta UDP $1: $2",
            "Error reading from socket: $1": "Erro ao ler do soquete: $1",
            "Error reading from socket: Operation timed out.": "Erro ao ler do soquete: o tempo de operação expirou.",
            "Error resolving hostname \"$1\": $2": "Erro ao resolver o nome do host \"$1\": $2",
            "Error setting socket to listen mode: $1": "Erro ao alterar o soquete para modo local: $1",
            "Error writing to socket: $1": "Erro ao escrever no soquete: $1",
            "Error writing to socket: Operation timed out.": "Erro ao escrever no soquete: o tempo de operação expirou.",
            "Format error in data received from the server.": "Erro de formatação nos dados recebidos do servidor.",
            "Incorrect data received from master server.": "Dados incorretos recebidos do servidor mestre.",
            "Master talker: (Quit) There was an unexpected error while sending information to the master list. See log/master.log.": "Comunicador mestre: (Quit) Houve um erro inesperado ao enviar informações para a lista mestra. Veja log/master.log.",
            "Master talker: There was an unexpected error while sending information to the master list. See log/master.log. To suppress this error, make the server private by using the -priv argument.": "Comunicador mestre: Houve um erro inesperado ao enviar informações para a lista mestra. Veja log/master.log. Para suprimir esse erro, torne o servidor privado usando o argumento -priv.",
            "Can't open $1 for writing.": "Não é possível abrir $1 para escrita.",
            "Can't save player password to '$1'!": "Não é possível salvar senha do jogador para '$1'!",
            "Can't write '$1'.": "Não é possível escrever '$1'.",
            "config/language.txt can't be written.": "config/language.txt não pode ser escrito.",
            "Error writing to '$1'.": "Erro ao escrever para '$1'.",
            "File download: Can't open '$1' for writing.": "Download de arquivos: Não é possível abrir '$1' para escrita.",
            "Map picture saver: Can't save map picture to '$1'.": "Salvamento de fotos dos mapas: Não é possível salvar foto para '$1'.",
            "The directory '$1' was not found and could not be created.": "O diretório '$1' não foi encontrado e não pôde ser criado.",
            "Shutdown: ABORTING $1 ranking updates": "Shutdown: ABORTING $1 ranking updates",
            "Shutdown: admin shell threads": "Shutdown: admin shell threads",
            "Shutdown: bot thread": "Shutdown: bot thread",
            "Shutdown: main thread": "Shutdown: main thread",
            "Shutdown: master talker thread": "Shutdown: master talker thread",
            "Shutdown: net server": "Shutdown: net server",
            "Shutdown: relay thread": "Shutdown: relay thread",
            "Shutdown: waiting for $1 ranking updates": "Shutdown: waiting for $1 ranking updates",
            "Shutdown: website thread": "Shutdown: website thread",
            "This file is automatically rewritten whenever the ban list changes.": "This file is automatically rewritten whenever the ban list changes.",
            "To reserve a name add a row:": "To reserve a name add a row:",
            "user <name> <tab> <password>  or  admin <name> [<tab> <password>]": "user <name> <tab> <password>  or  admin <name> [<tab> <password>]",
            "where <tab> is a tabulator character.": "where <tab> is a tabulator character.",
            "Passwordless admins need to authenticate by logging in to the ranking.": "Passwordless admins need to authenticate by logging in to the ranking."
        },
        "help": [
            "Para mais informações acesse estas fontes:",
            " ",
            " Documentação do jogo        diretório 'doc'",
            " Site finlandês do Outgun    http://outgun.mbnet.fi/",
            " Site brasileiro do Outgun   http://outgun.sf.net/",
            " ",
            "Controles",
            " ",
            " Mover                Setas ou teclado numérico",
            " Atirar               Control",
            " Correr               Shift",
            " Esquivar             Alt ou Alt Gr",
            " ",
            "Outras teclas",
            " ",
            " Conversar            Digite sua mensagem e aperte Enter",
            " Conversar com o time Comece sua mensagem com um ponto ('.')",
            " Mudar de time        Control + End",
            " Suicídio             Delete",
            " Soltar bandeira      Page Down",
            " Lista de mapas       F2",
            " Estat. dos times     F3",
            " Estat. dos jogadores F4",
            " Inform. do servidor  F5",
            " Mudar de mapa        F8",
            " Captura de tela      F11",
            " Mostrar mensagens    Insert",
            " ",
            "Conceito do jogo",
            " ",
            " Você é um membro de um time, vermelho ou azul, definido ao acaso quando você se conectar. Seu objetivo é ajudar seu time a vencer, capturando a bandeira inimiga. Para capturar a bandeira, um membro do seu time deve roubar a bandeira inimiga e trazê-la para a bandeira do seu time, desde que também não tenha sido roubada! Capiche?",
            " ",
            "Vida e energia",
            " ",
            " Se sua vida cai para zero, você morre. A energia é usada para correr, atirar e proteção de vida quando você tem o poder do escudo (você saberá quando vê-lo). Vida e energia se regeneram até 200 com o tempo.",
            " ",
            "Minimapa",
            " ",
            " No canto superior direito da tela está o minimapa. Ele mostra seus companheiros de time e os adversários vistos por eles. Se você tem o poder da sombra, mostra todos os oponentes que não tenham a sombra eles mesmos.",
            " ",
            "Poderes",
            " ",
            " Se você vir um item deitado no chão, agarre-o. É um item especial de poder.",
            " ",
            " Weapon upgrade  Um foguete adicional e mais energia",
            " Turbo           Mais velocidade",
            " Shadow          Invisibilidade, ver oponentes no minimapa",
            " Power           Seus tiros causam mais dano",
            " Megahealth      Mais vida e energia",
            " Shield          Sua vida é protegida enquanto o escudo durar",
            " Deathbringer    Causa dano aos jogadores na mesma sala quando morrer"
        ],
        "splash": [
            "Outgun 1.0.3 r617M, copyright © 2002-2010 vários autores.",
            " ",
            "Outgun é um software livre sob a GPL GNU, e você é bem-vindo a redistribuí-lo sob certas condições. Outgun vem com ABSOLUTAMENTE NENHUMA GARANTIA. Para obter detalhes, consulte o arquivo COPYING.",
            " ",
            "Para nos ajudar a remover quaisquer bugs restantes, você pode deixar o Outgun enviar automaticamente uma notificação quando ocorrer uma falha inesperada. Você pode escolher entre nenhum relatório, informações mínimas e um relatório completo. As informações mínimas não incluem mais do que o nome do arquivo, o número da linha da declaração de falha e a versão do Outgun. O relatório completo também inclui uma cópia da pilha do Outgun. Essas informações são usadas apenas para encontrar a causa da falha. Não podemos contatá-lo para obter mais informações, portanto, é recomendável enviar também um e-mail com mais detalhes.",
            " ",
            "Escolha o modo preferido abaixo com as teclas de seta para a esquerda e para a direita e feche o menu com Enter ou Esc. Após a primeira inicialização do Outgun, você pode encontrar esta tela no menu Opções."
        ]
    }
};
//# sourceMappingURL=catalogs.generated.js.map